import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { PlannedError } from './planned-error';

export class ErrorInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(catchError(error => throwError(() => this.handleError(error))));
  }

  handleError(error: unknown): unknown {
    if (error instanceof HttpErrorResponse && error.error.errorType) {
      return new PlannedError(error.error.errorType);
    } else if (error instanceof HttpErrorResponse && (error.status === 0 || error.status === 504)) {
      return new PlannedError('SERVER_UNREACHABLE');
    } else {
      return error;
    }
  }
}
